import React from 'react';
import PropTypes from 'prop-types';
import Utils from 'js/shared/utils';

// Component
import Modal from 'js/shared-order/components/Modal';
import ButtonCustom from 'js/shared-order/components/Button';

// Components(Material-UI)
import { Box, Grid } from '@material-ui/core';

// Utils
import { renderUrlImageS3 } from 'js/utils/helpers/image';

// Styles
import { userStylesPageStaff as useStyles } from './styles';


const ModalAddMenuChip = (props) => {
  const classes = useStyles();

  // props
  const { staffInfo, setStaffInfo, onClose, chipMenus, setChipMenus } = props;

  const addChipMenu = (chipMenu, index) => {
    const staffInfoClone = Utils.cloneDeep(staffInfo);
    const chipMenusClone = Utils.cloneDeep(chipMenus);
    const indexOfDeleteMenuChip = staffInfoClone?.delete_m_chip_menus?.indexOf(chipMenu.id);
    staffInfoClone.all_chip_menus = [...staffInfoClone.all_chip_menus, chipMenu];
    staffInfoClone.add_m_chip_menus = [...staffInfoClone.add_m_chip_menus, chipMenu.id];
    chipMenusClone.splice(index, 1);
    if (indexOfDeleteMenuChip > -1) {
      staffInfoClone?.delete_m_chip_menus?.splice(indexOfDeleteMenuChip, 1);
    }
    setChipMenus(chipMenusClone);
    setStaffInfo(staffInfoClone);
    onClose();
  };

  const actionModal = () => (
    <Box textAlign="center">
      <ButtonCustom
        title="戻る"
        borderRadius="28px"
        bgcolor="#828282"
        borderColor="#828282"
        width="176px"
        onClick={onClose}
      />
    </Box>
  );

  return (
    <Modal
      actions={actionModal()}
      open={props.open}
      title="アイテム選択"
      minHeight="375px"
      customClass={classes.cardContent}
    >
      <Grid container spacing={2} style={{ padding: '24px 16px' }}>
        {chipMenus.map((chipMenu, index) => {
          return (
            <Grid item xs={6} sm={3} md={2} key={index} className={classes.flexCenter}>
              <Box textAlign='right' fontWeight={600}>
                <img
                  width="80px"
                  height="80px"
                  src={renderUrlImageS3(chipMenu.main_image_path)}
                  onClick={() => addChipMenu(chipMenu, index)}
                  style={{marginBottom: 4, cursor: 'pointer'}}
                />
                {chipMenu?.price}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Modal>
  );
};

// PropTypes
ModalAddMenuChip.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  staffInfo: PropTypes.object,
  setStaffInfo: PropTypes.func,
  chipMenus: PropTypes.array,
  setChipMenus: PropTypes.func,
};

// defaultProps
ModalAddMenuChip.defaultProps = {
  open: false,
  onClose: () => {},
  staffInfo: {},
  setStaffInfo: () => {},
  chipMenus: [],
  setChipMenus: () => {},
};

export default ModalAddMenuChip;
